import { memo } from "react";
import {
  LineChart,
  Line,
  YAxis,
  XAxis,
  Tooltip,
  ReferenceLine,
  ResponsiveContainer,
} from "recharts";

/**
 * Compact dual-axis, two-line chart for use inside a data-grid cell.
 * Mirrors the COT page mini-chart: Managed Money net (left axis, stepped) vs
 * front-month close (right axis). DOM/SVG based, so it only works in grids
 * whose cells are real React nodes (TanStack, AG Grid, MUI) - not Glide canvas.
 */
export const DualLineChart = memo(function DualLineChart({
  data,
  height = 52,
}: {
  data: { i: number; price: number; mm: number }[];
  height?: number;
}) {
  if (!data || data.length < 2) return null;

  return (
    <div style={{ width: "100%", height }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 4, right: 2, bottom: 2, left: 2 }}>
          <XAxis dataKey="i" hide />
          <YAxis yAxisId="left" hide domain={["dataMin", "dataMax"]} />
          <YAxis
            yAxisId="right"
            orientation="right"
            hide
            domain={["dataMin", "dataMax"]}
          />
          <Tooltip
            allowEscapeViewBox={{ x: true, y: true }}
            wrapperStyle={{ zIndex: 1000 }}
            contentStyle={{
              fontSize: 11,
              padding: "10px 6px",
              borderRadius: 4,
            }}
            itemStyle={{ fontSize: 11, margin: 0, padding: 0, marginBottom: -20, marginTop: -20 }}
            labelFormatter={() => ""}
            formatter={(value: number, name: string) => [
              typeof value === "number" ? value.toLocaleString() : value,
              name === "mm" ? "MM Net" : "Close",
            ]}
          />
          <ReferenceLine y={0} yAxisId="left" stroke="#cbd5e1" strokeDasharray="3 3" />
          <Line
            yAxisId="left"
            type="stepAfter"
            dataKey="mm"
            stroke="#0d6efd"
            strokeWidth={1.5}
            dot={false}
            isAnimationActive={false}
          />
          <Line
            yAxisId="right"
            type="monotone"
            dataKey="price"
            stroke="#d63384"
            strokeWidth={1.5}
            dot={false}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
});

export default DualLineChart;
